import React, { Component } from 'react';
import Radium from 'radium';

import BubblesHeader from "./BubblesHeader";
import EditBubble from "./EditBubble";

class BubbleSettings extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showEditBubble: false
		};
	}
	
	onShowAddBubble() {
		this.setState({
			editingBubble: null,
			addNew: true,
			showEditBubble: true
		});
	}

	onShowEditBubble(bubble) {
		if (bubble) {
			this.setState({
				editingBubble: bubble,
				addNew: false,
				showEditBubble: true
			});
		}
		
	}

	render() {
		return (
			<div style={this.localStyles().bubbles}>
				<BubblesHeader
					bubbles={this.props.bubbles}
					style={this.props.style}
					allOn={true}
					onShowAddBubble={() => this.onShowAddBubble()}
					onSelectBubble={(bubble) => this.onShowEditBubble(bubble)}
				
				/>	

				<EditBubble
					style={this.props.style}
					type={this.state.addOrEdit}
					bubble={this.state.editingBubble}
					addNew={this.state.addNew}
					visible={this.state.showEditBubble}
					onReloadUserData={this.props.onReloadUserData}
					onHide={() => this.setState({showEditBubble: false})}
				/>

			</div>
		);
	}

	localStyles() {
		return {
			bubbles: {
				marginBottom: 20
			}
		}
	}
}

export default Radium(BubbleSettings);


// WEBPACK FOOTER //
// ./src/components/BubbleSettings.js